import React from "react";
import { OrbitComponent } from "../../../../../../../../base-components/orbit-component/orbit-component";
import { GamePlayPcHeaderBarRealDemoGameModeBox } from "../../../../boxes/game-mode/real-demo/game-play-pc-header-bar-real-demo-game-mode.box";
import {
    GameModeEnum
} from "../../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import { GamePlayPcHeaderBarDemoLabelBox } from "../../../../boxes/game-mode/demo-label/game-play-pc-header-bar-demo-label.box";
import {
    GamePlayPcHeaderBarGameModeToggleContainerBox
} from "../../../../boxes/game-mode/toggle-container/game-play-pc-header-bar-game-mode-toggle-container.box";
import { GamePlayPcHeaderBarGameModeToggleButtonBox } from "../../../../boxes/game-mode/toggle-button/game-play-pc-header-bar-game-mode-toggle-button.box";
import { CyClass } from "../../../../../../../../../../common/cy-classes";
import { GamePlayPcHeaderBarRealMoneyLabelBox } from "../../../../boxes/game-mode/real-money-label/game-play-pc-header-bar-real-money-label.box";
import { observer } from "mobx-react";

export const GamePlayPcHeaderBarRealDemoGameModeComponent = observer(
    class GamePlayPcHeaderBarRealDemoGameModeComponent extends OrbitComponent<{ gameMode: GameModeEnum }> {

        private _onRealLabelClick = async () => {
            if (this.props.gameMode === GameModeEnum.Real) {
                return;
            }

            await (await this.services.gameRunner).currentRunningGame?.switchToReal();
        }

        private _onDemoLabelClick = async () => {
            if (this.props.gameMode === GameModeEnum.Demo) {
                return;
            }

            await (await this.services.gameRunner).currentRunningGame?.switchToDemo();
        }

        private _onToggleClick = async () => {
            const isCurrentlyOnDemoMode = this.props.gameMode === GameModeEnum.Demo;
            if (isCurrentlyOnDemoMode) {
                await this._onRealLabelClick();
            } else {
                await this._onDemoLabelClick();
            }

            this._sendOrbitUserFlowEvent(isCurrentlyOnDemoMode);
        }

        private _sendOrbitUserFlowEvent = (isToggleToReal: boolean = true) => {
            const EventLabel = isToggleToReal ? 'Real' : 'Demo';
            this.services.analytics.sendOrbitUserFlowEvent('Game_Launcher', 'Toggle', EventLabel);
        }

        render() {
            const isInRealMode = this.props.gameMode === GameModeEnum.Real;

            return (
                <GamePlayPcHeaderBarRealDemoGameModeBox isInRealMode={isInRealMode}>
                    <GamePlayPcHeaderBarRealMoneyLabelBox isInRealMode={isInRealMode}
                        onClick={this._onRealLabelClick}
                        className={CyClass('cy-game-navbar-switch-to-real-label')}>
                        {this.services.translation.translate('GAME_WINDOW_MODE_REAL_LABEL')}
                    </GamePlayPcHeaderBarRealMoneyLabelBox>
                    <GamePlayPcHeaderBarGameModeToggleContainerBox isInRealMode={isInRealMode}
                        onClick={this._onToggleClick}
                        className={CyClass('cy-game-navbar-game-mode-toggle')}>
                        <GamePlayPcHeaderBarGameModeToggleButtonBox />
                    </GamePlayPcHeaderBarGameModeToggleContainerBox>
                    <GamePlayPcHeaderBarDemoLabelBox isInRealMode={isInRealMode}
                        onClick={this._onDemoLabelClick}
                        className={CyClass('cy-game-navbar-switch-to-demo-label')}>
                        {this.services.translation.translate('GAME_WINDOW_MODE_DEMO_LABEL')}
                    </GamePlayPcHeaderBarDemoLabelBox>
                </GamePlayPcHeaderBarRealDemoGameModeBox>
            );
        }
    }
);